<template lang="html">
  <section class="ctn-tutorial row" v-if="tutorial">
    <div class="inner-tuto white-box column">
      <div class="title">
				Fenêtre d’accès à la signature bloquée
      </div>
      <div class="label">
				Votre navigateur {{ userAgentBrowser.name }} a bloqué la fenêtre d’accès à la signature.
				Voici les instructions à suivre afin de débloquer la fenêtre d’accès.
      </div>
      <div class="master-slider column">
        <div class="inner-slider row">
          <div class="control-arrow" @click="previous">
            <span class="left icon-left-open-mini"></span>
          </div>
          <div class="slides">
            <div class="slide">
              <img :src="currentSlide.src" alt="">
            </div>
          </div>
          <div class="control-arrow" @click="next">
            <span class="right icon-right-open-mini"></span>
          </div>
        </div>
        <div class="controls row">
          <div class="round-control" v-for="(slide, key) in slides" v-bind:key="key" :class="{active: key === current}"
               @click="current = key"></div>
        </div>
        <div class="btn btn-gold" @click="setTutorial">
          <span v-if="current === (slides.length - 1)">Finir le tutoriel</span>
          <span v-else>Passer le tutoriel</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mapGetters} from 'vuex'
import ChromeStep0 from '@/common/assets/img/tuto-unlock-popup/chrome/step-0.png'
import ChromeStep1 from '@/common/assets/img/tuto-unlock-popup/chrome/step-1.png'
import ChromeStep2 from '@/common/assets/img/tuto-unlock-popup/chrome/step-2.png'

import FirefoxStep0 from '@/common/assets/img/tuto-unlock-popup/firefox/step-0.png'
import FirefoxStep1 from '@/common/assets/img/tuto-unlock-popup/firefox/step-1.png'
import FirefoxStep2 from '@/common/assets/img/tuto-unlock-popup/firefox/step-2.png'

import SafariStep0 from '@/common/assets/img/tuto-unlock-popup/safari/step-0.png'
import SafariStep1 from '@/common/assets/img/tuto-unlock-popup/safari/step-1.png'

import UAParser from 'ua-parser-js'

export default {
	name: 'UnlockSignaturePopupTutorial',
	data () {
		return {
			slides: [],
			chromeSlides: [
				{key: 0, src: ChromeStep0},
				{key: 1, src: ChromeStep1},
				{key: 2, src: ChromeStep2}
			],
			firefoxSlides: [
				{key: 0, src: FirefoxStep0},
				{key: 1, src: FirefoxStep1},
				{key: 2, src: FirefoxStep2}
			],
			safariSlides: [
				{key: 0, src: SafariStep0},
				{key: 1, src: SafariStep1}
			],
			current: 0,
			tutorial: true,
			userAgentBrowser: null
		}
	},
	mounted () {
		this.userAgentBrowser = (new UAParser()).getBrowser()

		this.initializeSlides()
	},
	methods: {
		initializeSlides () {
			if (this.userAgentBrowser.name.includes('Chrome')) {
				this.slides = this.chromeSlides
			} else if (this.userAgentBrowser.name.includes('Firefox')) {
				this.slides = this.firefoxSlides
			} else if (this.userAgentBrowser.name.includes('Safari')) {
				this.slides = this.safariSlides
			}
		},
		next () {
			if (this.current + 1 > this.slides.length - 1) {
				this.current = 0
			} else {
				this.current += 1
			}
		},
		previous () {
			if (this.current - 1 < 0) {
				this.current = this.slides.length - 1
			} else {
				this.current -= 1
			}
		},
		setTutorial () {
			this.tutorial = false
			this.$emit('close')
		}
	},
	computed: {
		currentSlide () {
			return this.slides[this.current]
		},
		...mapGetters({
			user: 'user'
		})
	}
}
</script>

<style lang="css">
	.inner-slider .slides {
		max-width: 800px !important;
	}
</style>



// WEBPACK FOOTER //
// UnlockSignaturePopupTutorial.vue?1e5f75b5